import { useAiChat } from '../../context/AiChatContext'

export function AiChatToggleButton() {
  const { toggle, isOpen } = useAiChat()

  return (
    <button
      onClick={toggle}
      aria-label="Discuter avec l'IA"
      aria-expanded={isOpen}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full cursor-pointer transition-colors text-white text-xs font-medium border ${
        isOpen
          ? 'bg-white/25 border-white/40 shadow-inner'
          : 'bg-white/10 border-transparent hover:bg-white/20'
      }`}
    >
      <span className="text-sm">✨</span>
      <span className="hidden sm:inline">Discuter avec l'IA</span>
    </button>
  )
}
